import { useT } from '../lib/i18n'

type SpinnerProps = { size?: number; className?: string; label?: string }

export function Spinner({ size = 20, className = '', label }: SpinnerProps) {
  const t = useT()
  return (
    <span role="status" aria-label={label ?? t('spinner.loading')} className={`inline-flex ${className}`}>
      <svg
        aria-hidden="true"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        className="animate-spin"
        fill="none"
        stroke="currentColor"
        strokeWidth={3}
        strokeLinecap="round"
      >
        <path d="M12 3a9 9 0 1 0 9 9" />
      </svg>
    </span>
  )
}
